import React, { useId, useRef, useState } from 'react';
import OurStorySec from './ourstorysections/OurStorySec';
import Section1 from './homesections/Section1';
import Section2 from './homesections/Section2';
import AppointmentBooking from "../assets/images/AppointmentBooking.svg";
import RepeatPrescriptionRequests from "../assets/images/RepeatPrescriptionRequests.svg";
import SecureMessaging from "../assets/images/SecureMessaging.svg";
import VirtualConsults from "../assets/images/VirtualConsults.svg";
import InstantAccessHealth from "../assets/images/InstantAccessHealth.svg";
import ResourcesYouTrust from "../assets/images/ResourcesYouTrust.svg";
import OnlinePayment from "../assets/images/OnlinePayment.svg";
import CareTeamCollaboration from "../assets/images/CareTeamCollaboration.svg";
import FamilyMember from "../assets/images/FamilyMember.svg";
import features from "../assets/images/new-features.webp"
import UsefulReminders from "../assets/images/UsefulReminders.svg";
import { Col, Container, Row } from 'react-bootstrap';
import { Image } from 'antd';
import { Spin } from 'antd';
import indiciWeb from '../assets/images/help-center-image.jpg'
import Section_one from './homesections/Section_one';
interface Ourstoryprops {
}

export const Features: React.FunctionComponent<Ourstoryprops> = (props) => {
    const appointment_booking =useRef(null)
    const secure_messaging=useRef(null)
    const [loading, setLoading]=useState(true)
    // const pageId1 = useId()
    setTimeout(() => {
      setLoading(false); // Hide loader after 8 seconds
  }, 3000);
    // const pageId1 = useId() 
    return (
            <React.Fragment>
            <div style={{background:'white'} } className='pb-5'>
                {loading ?<Spin spinning={loading} style={{fontSize:48}}   fullscreen /> :
                <Section_one background={features} title1={`Features`} flipHorizontal={true} />} 
            <OurStorySec classname={'featurescontainer'}>
                <Row className='shpbgrow py-5 align-items-center my-padding'>
                    <Col sm={12} className='py-5 pbottom'>
                        <p className='MyIndiciForContextTwo text-center'>
                            myindici contains a massive amount of features
                             tailored to meet your healthcare needs. 
                             Activities like booking 
                            appointments and requesting repeat prescriptions
                             are now easier than ever,
                            while having your medical data at your 
                            fingertips empowers you 
                            to make informed decisions about your
                             healthcare and your lifestyle. </p>
                    </Col>
                </Row >
            </OurStorySec>
            <Container className='featurescontainer'>
               <Row id="appointment_booking" className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className='text-center text-md-start'>
                        <Image  className='featuresWidth' src={AppointmentBooking}
                         preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Appointment Booking</h2>
                        <p className='MyIndiciForContext pt-2'>myindici’s booking interface has
                         been designed to ensure a quick, hassle-free experience.
                          Easily book appointments with your provider or other specialists, including face to face, phone and video
                           consultations. Quickly view your provider’s availability and jump instantly
                            to the next available slot with the click of a button. You can also easily
                             see and search all of your historical and upcoming appointments, and receive
                              appointment reminders straight to your device.</p>
                    </Col>
                </Row >
                <Row className='shpbgrow py-5 align-items-center '>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Repeat Prescription
                         Requests</h2>
                        <p className='MyIndiciForContext pt-2'>Need a repeat prescription? All
                         it takes is a few clicks to send your request directly to 
                         your practice. You can flag a request as urgent and mark 
                         whether you wish to pick it up from the practice or have
                          it sent straight to your local pharmacy. Notifications will 
                          inform you when your prescription  is ready.</p>
                    </Col>
                    <Col sm={12} md={3} className='text-center text-md-end'>
                        <Image className='featuresWidth' 
                        src={RepeatPrescriptionRequests} preview={false} />
                    </Col>
                </Row >
                <Row id="secure_messaging" ref={secure_messaging} className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className='text-center text-md-start'>
                        <Image className='featuresWidth' 
                        src={SecureMessaging} preview={false}  />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Secure Messaging</h2>
                        <p className='MyIndiciForContext pt-2'>myindici’s secure messaging tool 
                        enables you to efficiently interact 
                        with your provider or care team. Send and receive 
                        messages,
                         attach files and images, and more: myindici messaging 
                         complements the in-person care you receive from your 
                         provider with the ability to efficiently resolve queries
                          that don’t require an appointment.</p>
                    </Col>
                </Row >
                <Row  id="virtual_consults" className='shpbgrow py-5 align-items-center '>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders" >Virtual Consults</h2>
                        <p className='MyIndiciForContext pt-2'>Virtual consults can save you a
                         huge amount of time and hassle, especially if you live 
                         in a remote region. Or maybe you keep putting off a 
                         visit to the doctor because there’s no way to squeeze
                          it into your hectic daily routine. With myindici,
                           you can book and attend virtual consults from the 
                           comfort of your own home, giving you a practical, 
                           effective alternative to spending time in traffic 
                           jams and waiting rooms.</p>
                    </Col>
                    <Col sm={12} md={3} className='text-center text-md-end'>
                        <Image className='featuresWidth' src={VirtualConsults} preview={false} />
                    </Col>
                </Row>
                <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className='text-center text-md-start'>
                        <Image className='featuresWidth' src={InstantAccessHealth} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Instant Access to
                         your Health Information</h2>
                        <p className='MyIndiciForContext'>Instantly and securely access your 
                        health information no matter where you are. View lab 
                        results, doctor’s notes, immunization lists, diagnoses and 
                        more. Make informed decisions, and stay on top of your 
                        healthcare throughout your day to day life.</p>
                        {/* <ol>
                            <li className="para">
                                Care Team Collaboration
                            </li>
                            <li className="para">
                                Family Member and Career Access
                            </li>
                            <li className="para">
                                Proactive Care Reminders
                            </li>
                        </ol> */}
                    </Col>
                </Row>
                <Row className='shpbgrow py-5 align-items-center'>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Resources You can Trust</h2>
                        <p className='MyIndiciForContext'>We all know what it’s like to be at the
                         mercy of the Internet when Googling health queries. 
                         Information can be sensational, unproven, or straight up
                          fraudulent. Myindici supports a library of educational 
                          resources and guidance selected by your practice, so
                           you can have full confidence in the information you are 
                           accessing. Documents, videos and websites are
                            all supported, providing a platform for rich, useful,
                             verified content.</p>
                    </Col>
                    <Col sm={12} md={3} className='text-center text-md-end'>
                        <Image className='featuresWidth' src={ResourcesYouTrust} preview={false} />
                    </Col>
                </Row>
                <Row id="online_payment" className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className='text-center text-md-start'>
                        <Image className='featuresWidth'  src={OnlinePayment} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className=" mb-3 MyIndiciForProviders">Online Payment</h2>
                        <p className='MyIndiciForContext'>myindici is integrated with secure
                         online payment gateways, allowing you to easily pay your
                          bills with just a few clicks. myindici maintains a complete 
                          record of all invoices and payments, enabling you to 
                          view and download any of your previous transactions.</p>
                    </Col>
                </Row>
                <Row className='shpbgrow py-5 align-items-center '>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Care Team Collaboration</h2>
                        <p className='MyIndiciForContext'>myindici enables you to play an active 
                        role in any care plans created for your by your medical team.
                         You can view and interact with your goals and activities,
                          receive messages from your care team, book and attend 
                          appointments, and more, helping you to remain at the center
                           of your own health management.</p>
                    </Col>
                    <Col sm={12} md={3} className='text-center text-md-end'>
                        <Image className='featuresWidth' src={CareTeamCollaboration} preview={false} />
                    </Col>
                </Row>
                <Row className='shpbgrow py-5 align-items-center d-flex flex-wrap-reverse'>
                    <Col sm={12} md={3} className='text-center text-md-start'>
                        <Image className='featuresWidth' src={FamilyMember} preview={false} />
                    </Col>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Family Member / Carer Access</h2>
                        <p className='MyIndiciForContext'>myindici supports approved access to 
                        family member accounts or access by a carer once the patient 
                        has consented. For example, parents can access their kids’ 
                        accounts to manage their appointments, contact their doctor,
                         and more.</p>
                    </Col>
                </Row>
                <Row id="useful_reminders" className='shpbgrow py-5 align-items-center'>
                    <Col sm={12} md={9} className="text-center text-md-start my-margin">
                        <h2 className="mb-3 MyIndiciForProviders">Useful Reminders</h2>
                        <p className='MyIndiciForContext'>Effortlessly stay on top of your scheduled 
                        health events with myindici’s range of reminders, 
                        including for appointments, screenings, immunizations,
                         upcoming blood tests, and test results follow up. You 
                         can manage your notification settings for your reminders, 
                         enabling you to receive them via SMS, email or as 
                         push notifications straight to your phone,
                         whichever best works for you.</p>
                    </Col>
                    <Col sm={12} md={3} className='text-center text-md-end'>
                        <Image className='featuresWidth' src={UsefulReminders} preview={false} />
                    </Col>
                </Row>
            </Container>
            </div>
        </React.Fragment>
    )
}
export default Features;